import React, { useEffect } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import SummaryCard from '../../components/Cards/SummaryCard';
import DonutChart from '../../components/Charts/DonutChart';
import useInventoryDashboard from '../../hooks/dashboard/useInventoryDashboard';

const InventoryDashboard: React.FC = () => {
  const { stats, fetchStats } = useInventoryDashboard();

  // 👉 Estado para BarChart con rango de fechas

  useEffect(() => {
    fetchStats();
  }, []);

  // ✅ Construir dinámicamente labels y series
  const categoryLabels = Object.keys(stats.productsByCategory || {});
  const categorySeries = Object.values(stats.productsByCategory || {});

  const movementLabels = Object.keys(stats.movementsInOut || {});
  const movementSeries = Object.values(stats.movementsInOut || {});

  // ✅ Paletas de colores
  const categoryColors = [
    '#3C50E0',
    '#16A34A',
    '#F59E0B',
    '#F97316',
    '#10B981',
  ];
  const movementColors = ['#3C50E0', '#EF4444']; // Azul para entradas, rojo para salidas

  return (
    <DefaultLayout>
      {/* ✅ Tarjetas resumen */}
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6 xl:grid-cols-4 2xl:gap-7.5">
        <SummaryCard
          title="Productos Totales"
          value={stats.totalProducts.toString()}
          rate=""
          iconName="inventory"
        />
        <SummaryCard
          title="Productos con Bajo Stock"
          value={stats.lowStockProducts.toString()}
          rate=""
          iconName="warning"
        />
        <SummaryCard
          title="Productos Activos"
          value={stats.activeProducts.toString()}
          rate=""
          iconName="check-circle"
        />
        <SummaryCard
          title="Productos Inactivos"
          value={stats.inactiveProducts.toString()}
          rate=""
          iconName="x-circle"
        />
      </div>

      {/* ✅ Gráficos Donut */}
      <div className="mt-6 flex flex-col gap-4 md:flex-row md:gap-6">
        <div className="w-full md:w-1/2">
          <DonutChart
            title="Productos por categoría"
            labels={categoryLabels}
            series={categorySeries}
            colors={categoryColors.slice(0, categoryLabels.length)}
          />
        </div>

        <div className="w-full md:w-1/2">
          <DonutChart
            title="Movimientos de Inventario"
            labels={movementLabels}
            series={movementSeries}
            colors={movementColors.slice(0, movementLabels.length)}
          />
        </div>
      </div>
    </DefaultLayout>
  );
};

export default InventoryDashboard;
